import React from 'react';
import { Row, Col } from 'react-bootstrap';
import "./sideCourse.scss"
const SideCourses = () => {
    return (
        <>
            <div className="sidebar-courses-area">

                <div className="side-course-item">
                    <Row className="align-items-center">
                        <Col lg={4}>
                            <div className="img">
                                <img src="https://webtend.net/demo/html/wellco/assets/images/coach/small_1.jpg" alt="Image not found " />
                            </div>
                        </Col>
                        <Col lg={8}>
                            <div className="side-course-content">
                                <h4>কম্পিউটার অফিস অ্যাপ্লিকেশন </h4>
                                <p className="course-cat">  বাংলাদেশ কারিগরি শিক্ষা বোর্ড কর্তৃক অনুমোদিত Advanced IT Institute (প্রতিষ্ঠান কোড: ৫৬০৭৩)</p>
                                <p className="instructor">by Sanjoy Banik</p>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
};

export default SideCourses;